import { Link } from "react-router-dom";
import { useConfig } from "@/context/ConfigContext";

export function Logo({ dark = false, light = false }) {
  const cfg = useConfig();
  const creamText = dark || light;
  return (
    <Link to="/" className="flex items-center gap-3 group" data-testid="brand-logo">
      {cfg.logoUrl ? (
        <img src={cfg.logoUrl} alt="CLB — Chhannulal & Brothers logo" className="h-11 w-auto" />
      ) : (
        <span className="relative flex h-11 w-11 items-center justify-center bg-navy">
          <span className="absolute inset-[3px] border border-gold/70" aria-hidden="true" />
          <span className="font-display text-sm font-bold tracking-widest text-cream">CLB</span>
        </span>
      )}
      <span className="leading-tight">
        <span className={`block font-display text-[13px] font-semibold tracking-[0.18em] ${creamText ? "text-cream" : "text-darknavy"} group-hover:text-aqua transition-colors duration-300`}>
          CHHANNULAL &amp; BROTHERS
        </span>
        <span className={`block text-[10px] tracking-[0.28em] uppercase ${creamText ? "text-cream/60" : "text-navy/60"}`}>
          {cfg.tagline}
        </span>
      </span>
    </Link>
  );
}
